module.exports = __webpack_public_path__ + "static/media/img2-1.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/nutricheck_foliar/P/img2-1.png
// module id = 2456
// module chunks = 3